import times from 'lodash/times'

import { Skeleton } from '@/components/ui/skeleton'

export const TikTokMediaGridSkeleton = () => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-4">
      {times(8).map((i) => (
        <Skeleton
          key={i}
          className="h-full min-h-[417px] w-full"
        />
      ))}
    </div>
  )
}
